export default __webpack_public_path__ + "static/EcommApp-1ed37fd609cf913fd8d03299d29a0ab9.svg";